module.exports = __webpack_public_path__ + "static/media/SST INSTALA.7421c82a.png";